var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireRewardunFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3069 7.49128C11.023 4.88498 13.0319 1.20638 13.1182 1.05347C13.2432 0.835875 13.2428 0.568172 13.1171 0.350953C12.9914 0.133734 12.7595 0 12.5085 0C10.3034 0 8.57659 0.626531 7.37617 1.8623C5.32497 3.97373 5.42012 7.26 5.46076 8.6633C5.46531 8.81878 5.46916 8.95308 5.46916 9.05288C5.46916 10.0948 5.63631 11.0567 5.78383 11.9054C5.87889 12.4523 5.96097 12.9247 5.97559 13.2959C5.9912 13.6935 5.91859 13.7845 5.91555 13.7882C5.90519 13.8006 5.81889 13.8464 5.58573 13.8464C5.31976 13.8464 5.12373 13.7595 4.94997 13.5647C4.27141 12.8038 4.22448 10.7263 4.35423 9.59597C4.37744 9.39666 4.31439 9.19697 4.18094 9.04716C4.04753 8.89734 3.85647 8.81166 3.65589 8.81166C1.83034 8.81166 0.466187 11.797 0.466187 14.4663C0.466187 15.7211 0.718608 16.9502 1.21637 18.1197C1.69759 19.2503 2.38375 20.2706 3.256 21.1523C5.07236 22.9887 7.46734 24 9.99967 24C12.5423 24 14.9366 23.003 16.7417 21.1927C18.5422 19.387 19.5338 16.9982 19.5338 14.4662C19.5338 11.2355 17.006 8.52497 15.3069 7.49128Z",
    fill: "#B9BABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireRewardunFilled);
export default __webpack_public_path__ + "static/media/fireRewardunFilled.df6d6e6f72efc47d56d10c03b8a54e11.svg";
export { ForwardRef as ReactComponent };